const EMAIL_PREFERENCES = {
  EVERYONE: {display: 'EVERYONE', value: 'Everyone', showOrder: 0, def: false},
  CREATOR: {display: 'CREATOR', value: 'Creator', showOrder: 1, def: false},
};

export default EMAIL_PREFERENCES;